import React from 'react';
import { Grid } from '@mui/material';

import { Typography, ProductGroupSelectField, Select } from '@occc-app/design-system';
import {
  Earning_Mechanism_Product_Counting_Attribute,
  Earning_Mechanism_Product_Counting_Rounding_Strategy,
} from '@occc/graphql';

const selectData = [
  {
    value: Earning_Mechanism_Product_Counting_Rounding_Strategy.Raw,
    label: 'Raw',
  },
  {
    value: Earning_Mechanism_Product_Counting_Rounding_Strategy.Down,
    label: 'Down',
  },
  {
    value: Earning_Mechanism_Product_Counting_Rounding_Strategy.HalfUp,
    label: 'Half Up',
  },
];

const selectCountProductsByData = [
  {
    value: Earning_Mechanism_Product_Counting_Attribute.Quantity,
    label: 'Quantity',
  },
  {
    value: Earning_Mechanism_Product_Counting_Attribute.MoneyAmount,
    label: 'Money Amount',
  },
  {
    value: Earning_Mechanism_Product_Counting_Attribute.UnitsCount,
    label: 'Selling Unit',
  },
];

export const BaseEligibleEarnConfiguration: React.FC = () => {
  return (
    <>
      <Typography variant='subtitle1' paragraph>
        For every transaction
      </Typography>
      <Grid container spacing={3}>
        <Grid item sm={3}>
          <Select
            name='baseEligibleEarn.countProductsBy'
            label='Count By'
            data={selectCountProductsByData}
            formControlProps={{ size: 'medium', margin: 'none' }}
          />
        </Grid>
        <Grid item sm={3}>
          <Select
            name='baseEligibleEarn.roundCountedProducts'
            label='Rounded'
            data={selectData}
            formControlProps={{ size: 'medium', margin: 'none' }}
          />
        </Grid>
        <Grid item xs={6}>
          <ProductGroupSelectField
            inputProps={{
              margin: 'none',
            }}
            name='baseEligibleEarn.eligibleProductGroups'
            label='Product Groups'
          />
        </Grid>
      </Grid>
    </>
  );
};
